import { render } from "./appPicture-image.vue?vue&type=template&id=589e4c68&scoped=true"
import script from "./appPicture-image.vue?vue&type=script&lang=js"
export * from "./appPicture-image.vue?vue&type=script&lang=js"

import "./appPicture-image.vue?vue&type=style&index=0&id=589e4c68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589e4c68"]])

export default __exports__